import type { ValueOf } from "shared/types";
import { FEATURE_IDS, type FeatureKey } from "shared/types/features";

export type FeatureId = ValueOf<typeof FEATURE_IDS>;

export function getFeatureId(key: FeatureKey): FeatureId {
  return FEATURE_IDS[key];
}
